module.exports = __webpack_public_path__ + "static/media/1-3_Foiling_03.7cf429bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/1-3_Foiling_03.jpg
// module id = 564
// module chunks = 0